import { usePlanningStore } from '@planning/AppProvider'
import { InitializationWrapper } from '@planning/components/InitializationWrapper'
import { BerthPlanning } from '@planning/pages/BerthPlanning/BerthPlanning'
import { observer } from 'mobx-react-lite'
import { FC, useEffect, useMemo, useState } from 'react'
import { BerthPlanningViewStore } from './Stores/BerthPlanningViewStore'

type BerthPlanningViewWrapperProps = {
  headerActions?: JSX.Element
}

export const BerthPlanningViewWrapper: FC<BerthPlanningViewWrapperProps> = observer(
  ({ headerActions }) => {
    const { berthItemStore, vesselVisitItemStore, pierItemStore } = usePlanningStore()
    const [loading, setLoading] = useState(true)

    const berthPlanningViewStore = useMemo(
      () => new BerthPlanningViewStore(berthItemStore, vesselVisitItemStore, pierItemStore, 7),
      [berthItemStore, vesselVisitItemStore, pierItemStore],
    )

    useEffect(() => {
      berthPlanningViewStore.setViewMode(true)
      const initialize = async () => {
        try {
          await Promise.all([
            berthPlanningViewStore.fetchPiers(),
            berthPlanningViewStore.fetchVisits(),
          ])
        } finally {
          setLoading(false)
        }
      }

      initialize()
    }, [berthPlanningViewStore])

    return (
      <InitializationWrapper isInitializing={loading}>
        <BerthPlanning store={berthPlanningViewStore} headerActions={headerActions} />
      </InitializationWrapper>
    )
  },
)
